import React, { useState } from 'react';
import { Box, Typography, Card, CardContent, Grid, Tabs, TabList, Tab, TabPanel } from '@mui/joy';
import { Sparkle as AutoAwesome, Article, ChartLine as Analytics } from '@phosphor-icons/react';
import { TopicalMapManager } from '../../components/marketing/TopicalMapManager';
import { ArticleGenerator } from '../../components/marketing/ArticleGenerator';
import { ContentProgressTracker } from '../../components/marketing/ContentProgressTracker';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

export const ContentHub: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Fetch article statistics
  const { data: stats } = useQuery({
    queryKey: ['content-stats'],
    queryFn: async () => {
      const response = await api.get<{
        published_count: number;
        in_progress_count: number;
        blog_ideas_count: number;
      }>('/api/marketing/articles/stats/');
      return response.data;
    }
  });

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={{ xs: 1, md: 3 }} sx={{ mb: 3 }}>
        <Grid xs={4} md={4}>
          <Card variant="outlined">
            <CardContent>
              <Typography level="h4" sx={{ mb: 1, fontSize: { xs: '0.875rem', md: '1.25rem' } }}>Articles</Typography>
              <Typography level="h2" sx={{ fontSize: { xs: '1.5rem', md: '2.25rem' } }}>{stats?.published_count || 0}</Typography>
              <Typography level="body-sm" sx={{ fontSize: { xs: '0.7rem', md: '0.875rem' } }}>Published articles</Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid xs={4} md={4}>
          <Card variant="outlined">
            <CardContent>
              <Typography level="h4" sx={{ mb: 1, fontSize: { xs: '0.875rem', md: '1.25rem' } }}>In Progress</Typography>
              <Typography level="h2" sx={{ fontSize: { xs: '1.5rem', md: '2.25rem' } }}>{stats?.in_progress_count || 0}</Typography>
              <Typography level="body-sm" sx={{ fontSize: { xs: '0.7rem', md: '0.875rem' } }}>Being generated</Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid xs={4} md={4}>
          <Card variant="outlined">
            <CardContent>
              <Typography level="h4" sx={{ mb: 1, fontSize: { xs: '0.875rem', md: '1.25rem' } }}>Blog Ideas</Typography>
              <Typography level="h2" sx={{ fontSize: { xs: '1.5rem', md: '2.25rem' } }}>{stats?.blog_ideas_count || 0}</Typography>
              <Typography level="body-sm" sx={{ fontSize: { xs: '0.7rem', md: '0.875rem' } }}>Available ideas</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Card variant="outlined">
        <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value as number)} sx={{ width: '100%' }}>
          <TabList
            sx={{
              width: '100%',
              flexWrap: 'wrap',
              '& > *': { flex: { xs: '1 1 30%', sm: '0 0 auto' } },
            }}
          >
            <Tab>
              <AutoAwesome style={{ marginRight: 8 }} />
              Topical Maps
            </Tab>
            <Tab>
              <Article style={{ marginRight: 8 }} />
              Articles
            </Tab>
            <Tab>
              <Analytics style={{ marginRight: 8 }} />
              Progress Tracker
            </Tab>
          </TabList>
          
          <TabPanel value={0}>
            <TopicalMapManager />
          </TabPanel>
          
          <TabPanel value={1}>
            <ArticleGenerator />
          </TabPanel>
          
          <TabPanel value={2}>
            <ContentProgressTracker />
          </TabPanel>
        </Tabs>
      </Card>
    </Box>
  );
};